// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"fc38f3ec","365":"a83e024d","453":"6dd64769","589":"23881cc7","656":"4d4a8f2c"}[chunkId] + ".chunk.js";
};